module.exports = __webpack_public_path__ + "static/media/spanish-flag.e9c6da6e.png";